import { hash } from '@ember/helper';
import { service } from '@ember/service';

import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';
import { eq } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class RecordDetailFormsCategoryComponent extends Component {
  // Services
  @service data;

  // Defaults
  types = [
    'A_SUB_TYPE',
    'A_TYPE',
    'ADSERVER',
    'AUDIO_VIDEO_TYPE',
    'AUDIOFORMAT',
    'CHART',
    'COMPILATIONTYPE',
    'CONFIGURATION',
    'CONTENT_TYPE',
    'CONTRIB_FUNC',
    'COUNTRY',
    'DELIVERYSTATE',
    'DIGI_MEDIA',
    'DIGI_PRODUCT',
    'DOCUMENT_TYPE',
    'DVDCOUNTRYCODE',
    'EDITION',
    'EXT_SERVICE',
    'FORMAT',
    'FSK',
    'GENDER',
    'GENRE',
    'GRAPHIC_TYPE',
    'INSTRUMENT',
    'JOB_FUNCTION',
    'JOB_TYPE',
    'KARUSSELL',
    'LINK',
    'MEDIA_EMBED',
    'MFD_CATEGORY',
    'MFD_NEWS_SUBCATEGORY',
    'MFD_SUBCATEGORY',
    'P_TYPE_COOP',
    'P_TYPE_LIVE',
    'P_TYPE_MEDIA',
    'P_TYPE_ONOFF',
    'P_TYPE_PUBLISH',
    'P_TYPE_TRADE',
    'PAGETITLE',
    'POSITION',
    'PRODUCTCATEGORY',
    'PRODUCTFAMILY',
    'PRODUCTGROUP',
    'PRODUCTSUBCATEGORY',
    'PROVINCE',
    'SHOP_TYPE',
    'SHOP',
    'SOFTWARE_TYPE',
    'SUBGENRE',
    'T_TYPE_CAL',
    'T_TYPE_LIVE',
    'T_TYPE_MEDIA',
    'TARGET_GROUP',
    'TEASER_STANDALONE_TYPE',
    'TICKET_SHOP',
    'TITLE',
    'TOPIC',
    'TOUR',
    'UTM_CONTENT',
    'UTM_MEDIUM',
    'UTM_SOURCE',
    'VIDEOFORMAT',
    'VIDEOSTANDARD',
    'WHERE_HEARED',
    'YOUTUBECHANNEL',
    'YOUTUBEPOLICY',
  ];

  // Getter and setter
  get typeOptions() {
    return labelValueOptions.call(this, this.types, [
      'forms.category.options.type',
    ]);
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='name' />
            <fieldset.field @property='shortName' />
            <fieldset.field @property='teaserText' @type='text-editor' />
            <fieldset.field @property='description' @type='text-editor' />

            <fieldset.field
              @property='type'
              @type='select-value'
              @isSearchEnabled={{true}}
              @searchField='label'
              @options={{this.typeOptions}}
            />

            {{#if (eq @model.type 'SHOP')}}
              <fieldset.field
                @property='tradePartner'
                @type='belongs-to'
                @on={{hash openNewRecord=false}}
              />

              <fieldset.field
                @property='exclusiveForAudioplayers'
                @type='checkbox'
              />
            {{/if}}

            <fieldset.field @property='svgUrl' />
            <fieldset.field @property='mmcId' @type='number' />

            <fieldset.field
              @property='topCategory'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='externalReferences'
              @type='has-many'
              @hasManySortable={{false}}
              @on={{hash
                openNewRecord=this.newRecord
                deleteRecord=this.deleteRelation
                openRecord=false
                openRecordList=false
              }}
              as |record field|
            >
              <CpPanel @open={{record.isNew}} as |panel|>
                <panel.toggle>
                  {{record.type.name}}
                  |
                  {{record.val}}
                </panel.toggle>
                <panel.body>
                  <Form
                    @model={{record}}
                    @parentModel={{form.model}}
                    @showErrors={{@showErrors}}
                    as |subform|
                  >
                    <subform.field
                      @property='type'
                      @type='select-record'
                      @disabled={{field.isDisabled}}
                      @isSearchEnabled={{true}}
                      @options={{this.data.externalReferenceServices}}
                    />
                    <subform.field
                      @property='val'
                      @disabled={{field.isDisabled}}
                    />
                    <subform.field
                      @property='param'
                      @disabled={{field.isDisabled}}
                    />
                  </Form>
                </panel.body>
              </CpPanel>
            </fieldset.field>
          </form.fieldset>
          <form.sections.seo />
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
